import * as React from 'react';
import FileProviderView from './FileProviderView';
import HeaderContainer from './HeaderContainer';
import { FileProviderType, FileProviderViewState } from 'owa-fileprovider-store';
import { observer } from 'mobx-react-lite';

const styles = require('./StorageAccountsListView.scss');

export interface StorageAccountsListViewProps {
    header: string;
    storageAccounts: FileProviderViewState[];
    onRemoveHandler?: (providerType: FileProviderType) => void;
}

const StorageAccountsListView = observer(function StorageAccountsListView(
    props: StorageAccountsListViewProps
) {
    return (
        <HeaderContainer className={styles.container} header={props.header}>
            <div>
                {props.storageAccounts.map(storageAccount => {
                    const removeHandler =
                        props.onRemoveHandler && (() => props.onRemoveHandler(storageAccount.type));

                    return (
                        <div key={storageAccount.model.Id} className={styles.storageAccount}>
                            <FileProviderView
                                providerType={storageAccount.type}
                                providerName={storageAccount.name}
                                displayText={storageAccount.model.AssociatedDataProviderAccountId}
                                onRemoveClicked={removeHandler}
                            />
                        </div>
                    );
                })}
            </div>
        </HeaderContainer>
    );
});
export default StorageAccountsListView;
